import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useAccount } from '../account/store.ts';
import { apiMessage } from '../api/errors.ts';
import { api } from '../api/instance.ts';
import { services } from '../services/index.ts';
import { toast } from '../state/feedback.ts';
import { Button } from '../ui/Button.tsx';
import { Logo } from '../ui/Logo.tsx';

/** /invite?token=…: join a company (sign in first). */
export function InviteScreen() {
  const { token } = useSearch({ from: '/invite' });
  const navigate = useNavigate();
  const session = useAccount((a) => a.session);
  const ready = useAccount((a) => a.ready);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (ready && !session)
      void navigate({
        to: '/signin',
        search: { next: `/invite?token=${encodeURIComponent(token ?? '')}` },
        replace: true,
      });
  }, [ready, session, token, navigate]);
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
      <Logo width={48} />
      <h1 className="t-title">Join your company on Better Lights</h1>
      <p className="t-body max-w-[360px] text-dim">You’ll share the company’s projects, price list and branding.</p>
      <Button
        variant="primary"
        loading={busy}
        disabled={!token || !session}
        onClick={async () => {
          setBusy(true);
          try {
            const m = await api.acceptInvite(token!);
            await services.account.refreshMe();
            services.account.setActiveScope(m.orgId);
            toast('You joined the company', 'success');
            await navigate({ to: '/team/$orgId', params: { orgId: m.orgId } });
          } catch (e) {
            toast(apiMessage(e, 'This invite can’t be used.'), 'error');
          } finally {
            setBusy(false);
          }
        }}
      >
        Accept invite
      </Button>
    </main>
  );
}
